function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-ya-2x-secret-a",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C8CF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#78787D",
  offset: "60.065%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#77787D",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "avatar-ya-2x-secret-b",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("path", {
  id: "avatar-ya-2x-secret-c",
  d: "M6.5 39.756V24.114C6.5 14.4 14.4 6.5 24.114 6.5h46.772C80.6 6.5 88.5 14.4 88.5 24.114v15.66c-.228 1.783-1.51 2.912-3.268 2.912H53.69c-.925 0-1.313-.31-1.313-1.45V31.25c0-1.185.538-1.185 1.732-1.185h18.88c1.88 0 1.945-1.257 1.945-2.252v-3.658c0-1.124 0-2.453-1.945-2.453H41.626c-1.485 0-1.6-1.25-.5-2.64C42.228 17.67 42.1 16 40.69 16h-7.055c-.71 0-1.322.67-2.016 1.718-4.736 7.142-6.606 8.13-10.26 10.745-1.515 1.084-1.826 2.087-1.826 3.42v4.435c0 1.696 1.628 1.76 3.007 1.343 3.724-1.123 9.186-5.593 9.785-6.41.6-.813.86-1.184 2.116-1.184h6.685c1.315 0 1.315 1.07 1.315 1.82v9.35c0 .75-.314 1.45-1.314 1.45H9.64c-1.366 0-2.815-.763-3.14-2.93zm0 14.29v16.84C6.5 80.6 14.4 88.5 24.114 88.5h46.772C80.6 88.5 88.5 80.6 88.5 70.886V54.268c-.246-1.458-1.712-2.872-3.268-2.872H54.11c-.715 0-1.182.778-.723 1.577 4.528 7.875 14.18 13.642 23.79 16.757.924.3 1.824 1.005 1.824 3.086v4.835c0 1.06-.774 1.86-2.225 1.533-21.39-4.81-27.722-16.734-28.726-18.455-.28-.48-1.055-.425-1.365 0-1.02 1.4-7.89 15.047-27.592 18.76-1.493.282-3.394-.016-3.394-1.836v-4.834c0-1.176.3-2.132 2.04-2.652 15.896-4.753 20.855-13.65 22.95-17.346.584-1.026-.39-1.422-.974-1.422H9.64c-2.12 0-2.92 1.024-3.14 2.65z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-ya-2x-secret-a)",
  xlinkHref: "#avatar-ya-2x-secret-b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-ya-2x-secret-c"
}));

var SvgYa = function SvgYa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ya.748c6d1f.svg";
export { ForwardRef as ReactComponent };